// extracted by mini-css-extract-plugin
export default {"wrap":"SingleRow_wrap__TnIUX"};